// extracted by mini-css-extract-plugin
export default {"container":"QuemSomos_container__xkB68","card":"QuemSomos_card__Steu3","title":"QuemSomos_title__p8J5z"};